import React from 'react';
import styled from 'styled-components';


const WelcomeContainer = styled.div`
  text-align: center;
  margin-top: 30px;

  @media (max-width: 768px) {
    margin-top: 0px;
  }
`;

const WelcomeTitle = styled.h1`
  font-size: 64px;
  font-family: Sansita Swashed;
  color: white;
  font-weight: 600;

  @media (max-width: 768px) {
    color: #002E3B;
    font-size: 48px; 
  }
`;

const LoginPrompt = styled.h1`
  font-size: 30px;
  font-family: Public Sans;
  color: #002E3B;
  font-weight: 900; 

  @media (max-width: 768px) {
    font-size: 22px; 
  }
`;

const WelcomeLogin = () => {
  return (
    <WelcomeContainer>
      <WelcomeTitle>Bem-vindo!</WelcomeTitle>
      <LoginPrompt>Faça o login</LoginPrompt>
    </WelcomeContainer>
  );
};

export default WelcomeLogin;
